import React from "react";

const ArrowDownSFillIcon = () => (
	<g>
		<path d='M12 16L6 10H18L12 16Z' />
	</g>
);

export default ArrowDownSFillIcon;
